var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.682,
    height: 28.61,
    viewBox: "0 0 130.682 28.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "polygon",
    transform: "translate(0 0.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1705846844560",
    transform: "translate(0 -0.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62298",
    "data-name": "Group 62298",
    transform: "translate(40.682 3.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108768",
    "data-name": "Path 108768",
    d: "M778.305,180.421V162.435h2.687l.235,1.458h.141a4.693,4.693,0,0,1,3.863-1.694c3.3,0,5.98,2.687,5.98,6.685s-2.64,6.685-5.985,6.685a4.526,4.526,0,0,1-3.675-1.6h-.141v6.4H778.3v.047Zm9.8-11.536c0-2.352-1.505-3.816-3.345-3.816s-3.345,1.458-3.345,3.816,1.505,3.816,3.345,3.816S788.1,171.243,788.1,168.885Z",
    transform: "translate(-778.3 -157.49)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108769",
    "data-name": "Path 108769",
    d: "M1055,168.885a6.546,6.546,0,1,1,6.544,6.685A6.422,6.422,0,0,1,1055,168.885Zm9.979,0a3.458,3.458,0,1,0-3.439,3.816A3.5,3.5,0,0,0,1064.979,168.885Z",
    transform: "translate(-1040.537 -157.49)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108770",
    "data-name": "Path 108770",
    d: "M1348.6,89.945V72.1h3.11V89.945Z",
    transform: "translate(-1318.79 -72.1)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108771",
    "data-name": "Path 108771",
    d: "M1443.566,166.605h3.3l-5.6,15.681a3,3,0,0,1-3.345,2.305H1434.9v-2.875h2.54a.823.823,0,0,0,.847-.612l.282-.847L1433.3,166.6h3.3l3.345,8.949h.518l3.016-8.949h.089Z",
    transform: "translate(-1399.063 -161.66)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108772",
    "data-name": "Path 108772",
    d: "M1697.771,176h3.157c.141.847.988,1.976,2.969,1.976a2.86,2.86,0,0,0,3.11-2.969v-1.788h-.141a4.934,4.934,0,0,1-3.581,1.411,6.224,6.224,0,0,1,0-12.43,4.823,4.823,0,0,1,3.769,1.647h.141l.235-1.411h2.687v12.571c0,3.439-2.305,5.7-6.215,5.7-4.391,0-6.037-2.87-6.131-4.7Zm9.184-7.584a3.234,3.234,0,1,0-3.252,3.439A3.248,3.248,0,0,0,1706.955,168.415Z",
    transform: "translate(-1649.358 -157.49)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108773",
    "data-name": "Path 108773",
    d: "M1981.1,168.885a6.546,6.546,0,1,1,6.544,6.685A6.422,6.422,0,0,1,1981.1,168.885Zm9.984,0a3.458,3.458,0,1,0-3.439,3.816A3.53,3.53,0,0,0,1991.083,168.885Z",
    transform: "translate(-1918.229 -157.49)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108774",
    "data-name": "Path 108774",
    d: "M2273,175.336v-12.9h2.687l.235,1.223h.141a5.1,5.1,0,0,1,3.721-1.458c2.969,0,5.086,2.117,5.086,5.415v7.767h-3.111v-7.344a2.751,2.751,0,0,0-2.78-2.875,2.853,2.853,0,0,0-2.875,2.875v7.344H2273Z",
    transform: "translate(-2194.871 -157.49)",
    fill: "#1228f3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_108775",
    "data-name": "Path 108775",
    d: "M23.924,19.469l7.626-4.427a1.267,1.267,0,0,0,.659-1.129V5.058a1.267,1.267,0,0,0-.659-1.129L23.924-.5a1.318,1.318,0,0,0-1.317,0L14.975,3.929a1.267,1.267,0,0,0-.659,1.129V20.833l-5.368,3.11-5.368-3.11V14.665l5.368-3.11,3.533,2.023V9.433L9.607,7.786A1.531,1.531,0,0,0,8.949,7.6a1.08,1.08,0,0,0-.659.188L.659,12.219A1.267,1.267,0,0,0,0,13.348V22.2a1.267,1.267,0,0,0,.659,1.129l7.626,4.427a1.318,1.318,0,0,0,1.317,0l7.626-4.427a1.267,1.267,0,0,0,.659-1.129V6.427l.094-.047L23.26,3.317l5.368,3.11V12.6L23.26,15.7l-3.533-2.023v4.145L22.6,19.469a1.327,1.327,0,0,0,1.322,0Z",
    transform: "translate(0 0.675)",
    fill: "#1228f3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.c9605b9445acd6f74429ddc0763eb058.svg";
export { ForwardRef as ReactComponent };